/**
 * @generated SignedSource<<e5d41e39f29baa97850e05de89242b59>>
 * @relayHash 8fe745c218cf57d4e397bd315f4402bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d2fb6fd0704b9a47ce58cdbd68b7d323ee9dd5f709e4cda872d4106b48e2f986

import type { ConcreteRequest, Query } from 'relay-runtime';
export type mainGroupByDropdownContentQuery$variables = {
  nodeId: string;
};
export type mainGroupByDropdownContentQuery$data = {
  readonly node: {
    readonly __typename: "JiraGroupedListView";
    readonly id: string;
    readonly viewSettings: {
      readonly __id: string;
      readonly groupByConfig: {
        readonly availableGroupByFieldOptions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly fieldId: string;
              readonly id: string;
              readonly name: string;
              readonly typeKey: string;
            };
          } | null | undefined> | null | undefined;
        };
      };
      readonly isGroupingEnabled: boolean | null | undefined;
    };
  } | {
    readonly __typename: "JiraListView";
    readonly id: string;
    readonly viewSettings: {
      readonly __id: string;
      readonly groupByConfig: {
        readonly availableGroupByFieldOptions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly fieldId: string;
              readonly id: string;
              readonly name: string;
              readonly typeKey: string;
            };
          } | null | undefined> | null | undefined;
        };
      };
      readonly isGroupingEnabled: boolean | null | undefined;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type mainGroupByDropdownContentQuery = {
  response: mainGroupByDropdownContentQuery$data;
  variables: mainGroupByDropdownContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "nodeId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "isGroupingEnabled"
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v8 = {
  "kind": "ScalarField",
  "name": "typeKey"
},
v9 = {
  "kind": "ScalarField",
  "name": "__id"
},
v10 = [
  {
    "kind": "RequiredField",
    "field": (v3/*: any*/),
    "action": "THROW",
    "path": "node.id"
  },
  {
    "kind": "RequiredField",
    "field": {
      "concreteType": "JiraIssueSearchViewConfigSettings",
      "kind": "LinkedField",
      "name": "viewSettings",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "kind": "RequiredField",
          "field": {
            "concreteType": "JiraSpreadsheetGroupByConfig",
            "kind": "LinkedField",
            "name": "groupByConfig",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "args": (v5/*: any*/),
                  "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                  "kind": "LinkedField",
                  "name": "availableGroupByFieldOptions",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraField",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "RequiredField",
                                "field": (v6/*: any*/),
                                "action": "THROW",
                                "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node.name"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v7/*: any*/),
                                "action": "THROW",
                                "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node.fieldId"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v8/*: any*/),
                                "action": "THROW",
                                "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node.typeKey"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node"
                        }
                      ]
                    }
                  ],
                  "storageKey": "availableGroupByFieldOptions(first:10)"
                },
                "action": "THROW",
                "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions"
              }
            ]
          },
          "action": "THROW",
          "path": "node.viewSettings.groupByConfig"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v9/*: any*/),
              "action": "THROW",
              "path": "node.viewSettings.__id"
            }
          ]
        }
      ]
    },
    "action": "THROW",
    "path": "node.viewSettings"
  }
],
v11 = [
  {
    "concreteType": "JiraIssueSearchViewConfigSettings",
    "kind": "LinkedField",
    "name": "viewSettings",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
            "kind": "LinkedField",
            "name": "availableGroupByFieldOptions",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraField",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "availableGroupByFieldOptions(first:10)"
          }
        ]
      },
      {
        "kind": "ClientExtension",
        "selections": [
          (v9/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "mainGroupByDropdownContentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v10/*: any*/),
            "type": "JiraGroupedListView"
          },
          {
            "kind": "InlineFragment",
            "selections": (v10/*: any*/),
            "type": "JiraListView"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mainGroupByDropdownContentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "JiraGroupedListView"
          },
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "JiraListView"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d2fb6fd0704b9a47ce58cdbd68b7d323ee9dd5f709e4cda872d4106b48e2f986",
    "metadata": {},
    "name": "mainGroupByDropdownContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "cfedde1950e620d05847ca1045ac87a5";

export default node;
